import * as d3 from 'd3'
export default {
  methods: {

    gmx_InputBox(selection, inputSet, sx=0) {
      
      inputSet.filter(f=> f.label).forEach(d=> {
        if(!d.type) d.type = ''

        let inputGroup = selection
        .append('g')
        .attr('id', `INPUT_${d.id}`)
        .attr('transform', `translate(${d.x}, ${d.y})`)
        .attr('visibility', d.type=='hidden' ? 'hidden' : 'display')

        inputGroup
        .append('text')
        .attr('id', `LABEL_${d.id}`)
        .attr('x', 0).attr('y', 0)
        .attr('fill', d.lColor ? d.lColor : '#757575').attr('text-anchor', 'start')
        .attr('font-size', 10).attr('font-style', 'italic')
        .text(d.label)
        if(d.align){
          let x_ = d.x ?  d.x : sx
          let label = d3.select(`#LABEL_${d.id}`)
          if(d.align == 'middle') label.attr('x', x_ + (d.width/2)).attr('text-anchor', 'middle')
          if(d.align == 'end') label.attr('x', x_ + d.width).attr('text-anchor', 'end')
        }

        inputGroup
        .append("foreignObject")
        .attr('id', `FOREIGN_${d.id}`)
        .attr('x', 0).attr('y', 3).attr('width', d.width).attr('height', 25)
        .append('xhtml:div').append('div')
        .attr('spellcheck', 'false')
        .attr('id', `FORM_${d.id}`)
        .attr('class', 'input')
        .style('padding', '2px 5px')
        .style('border', d.type=='fixed' ? '0px' :'1px solid #ccc')
        .style('border-bottom', d.type=='fixed' ? '1px solid #ccc' : '')
        // .style('color', d.tColor ?  d.tColor : '#333')
        .attr('contentEditable', d.type=='fixed' ? false : true)
        .text(d.value==0 || d.value ? d.value  : '')

        .on('click', function () {
          if(d.type=='fixed') return
          d3.select(this).style('border', d.type=='date' ? '1px solid #ccc' : '1.5px solid #B4E3FA')
          d3.select(`#LABEL_${d.id}`).attr('fill', '#44A9DF')
        })
        .on('blur', function () {
          d3.select(this).style('border', '1px solid #ccc')
          d3.select(`#LABEL_${d.id}`).attr('fill', d.lColor ? d.lColor : '#757575')
        })
        .on('keydown', function(event) {
          if(!d.type || !d.type=='number') return
          if (event.key >= '0' && event.key <= '9') return
          if (['Backspace', 'Delete',].includes(event.key)) return
          event.preventDefault()
        })
        .on('keyup', ()=> {
          // Verify Coloring
          if(d.verify) {
            d3.select(`#IFRAME_${this.CRT.id}`).attr('fill', inputSet.length == this.gmx_field_Coloring(inputSet) ? '#B4E3FA' : '#fff')
          }
        })
        .on('input', function () {
          function setCaretToEnd(el) {
            const range = document.createRange()
            const sel = window.getSelection()
            range.selectNodeContents(el)
            range.collapse(false)
            sel.removeAllRanges()
            sel.addRange(range)
          }
          if (this.innerText.length > d.maxLen) {
            this.innerText = this.innerText.slice(0, d.maxLen)
            setCaretToEnd(this)
          }
        })

        // Date Picker ---------------------------------------------
        if(d.type=='date') {
          d3.select(`#FORM_${d.id}`).attr('contentEditable', false)
          selection
          .append('image')
          .attr('xlink:href', this.HOST + `/Database/icon/Date.svg`).attr('cursor', 'pointer')
          .attr('x', d.x + d.width + 5).attr('y', d.y + 3).attr('width', 22).attr('opacity', .5)
          .on('mouseover', function() {
            d3.select(this).transition().duration(75).attr('opacity', 1)
          })
          .on('mouseout', function() {
            d3.select(this).transition().duration(250).attr('opacity', .5)
          })
          .on('click', () => {
            let setDate = d.value ? d3.select(`#FORM_${d.id}`).text() : new Date()
            this.gmx_datePicker(selection, {id: `#FORM_${d.id}`, date: setDate, x: d.x + d.width + 5, y: d.y + 3})
          })
        }

        if(!d.type=='hidden') sx += (d.width + 15)
      })
    },


    gmx_field_Coloring(inputSet) {
      let cnt = 0
      inputSet.forEach(d_=> {
        if(d3.select(`#FORM_${d_.id}`).empty()) return
        else if(d3.select(`#FORM_${d_.id}`).text()) cnt ++
      })

      return cnt
    },


  } 
}